let gsap = null;
let ScrollTrigger = false;

export default async () => {
    if (!gsap) {
        const importedGsap = await import('gsap/dist/gsap');
        ScrollTrigger = await import('gsap/dist/ScrollTrigger');
        ScrollTrigger = ScrollTrigger.ScrollTrigger;

        gsap = importedGsap.gsap;
        gsap.registerPlugin(ScrollTrigger);
    }
    return {
        gsap,
        ScrollTrigger,
    };
};
